// GLOBAL JS Functions -------------------
// ---------------------------------------

window.shopUtils = {
  // Parse the URL parameter
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },

  // apply the display classes for accordion.js
  toggleSection: function(element) {
    element.classList.toggle("active");
    element.nextElementSibling.classList.toggle("show");
    $(element).find(".expand").toggle();
    $(element).find(".contract").toggle();
  },

  toggleAllSections: function(element) {
    var expand = element.matches('.accordion-expand-all');
    element.disabled = true
    $(element).siblings("[disabled]").removeAttr("disabled");
    $(element.parentElement).siblings().filter(".accordion").each(function() {
      if (expand && !$(this).hasClass("active") || !expand && $(this).hasClass("active")) {
        window.shopUtils.toggleSection(this);
      }
    });
  }
}